export default __webpack_public_path__ + "static/media/avatar.10691648.png";